import { Injectable, signal, computed, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly _router = inject(Router);
  private readonly _activeCount = signal(0);

  readonly isLoading = computed(() => this._activeCount() > 0);

  constructor() {
    this._router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.reset());
  }

  show(): void {
    this._activeCount.update((c) => c + 1);
  }

  hide(): void {
    this._activeCount.update((c) => Math.max(0, c - 1));
  }

  reset(): void {
    this._activeCount.set(0);
  }
}
